import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { map, switchMap } from 'rxjs';

import { LanguagesService } from '../services/languages.service';

import * as TranslateActions from './translate.actions';

@Injectable()
export class TranslateEffects {
  private actions$ = inject(Actions);
  private translateService = inject(TranslateService);
  private languageService = inject(LanguagesService);

  loadLanguages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslateActions.loadLanguages),
      switchMap((action) => this.languageService.getLanguages(action.hotelUid)),
      map((languages) => TranslateActions.setLanguages({ languages })),
    ),
  );

  changeLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslateActions.changeLanguage),
      map((action) => {
        localStorage.setItem('lan', action.language.prefix);
        const getStorage = JSON.parse(localStorage['GetStorage'] ?? '{}');
        localStorage.setItem('GetStorage', JSON.stringify({ ...getStorage, lang: action.language.prefix }));
        const formattedLang = action.language.prefix.replace('-', '_');
        this.translateService.use(formattedLang);
        return TranslateActions.setActualLanguage({ actualLanguage: action.language });
      }),
    ),
  );
}
